import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["badge", "badgeColor", "badgeIcon", "badgeIconType", "badgeLabel", "badgeType", "current", "disabled", "dropdownMenu", "dropdownMenuProps", "label", "leadingIcon", "size", "sx", "textAlign", "type"];
/* eslint-disable sort-keys */
import React, { useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Badge } from '../../Badge';
import { getTabStyles } from './getTabStyles';
import MuiTab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Icon } from '../../Icon';
import { DropdownMenu } from '../../DropdownMenu';
import { Button } from '../../Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Base Zenith component that make up each tab of the Zenith Tabs component.
 */
export function TabButton(props) {
  var _tabStyles$type$curre, _tabStyles$type$curre2, _tabStyles$type$curre3, _tabStyles$type$curre4, _tabStyles$type$hover, _tabStyles$type, _tabStyles$type$hover2, _tabStyles$type$curre5, _tabStyles$type$curre6, _tabStyles$type$hover3, _tabStyles$type2, _tabStyles$type2$hove, _tabStyles$type$curre7, _tabStyles$type$curre8, _tabStyles$type$hover4, _tabStyles$type3, _tabStyles$type3$hove, _tabStyles$type$curre9, _tabStyles$type$curre0, _tabStyles$type$hover5, _tabStyles$type4, _tabStyles$type4$hove, _chevronRef$current$g, _chevronRef$current, _chevronRef$current$g2, _chevronRef$current2, _chevronRef$current$g3, _chevronRef$current3, _tabStyles$type$hover7, _tabStyles$type7, _tabStyles$type7$hove, _tabStyles$type8, _tabStyles$type8$hove, _tabStyles$type9, _tabStyles$type9$hove, _tabStyles$type0, _tabStyles$type0$hove, _tabStyles$type1, _tabStyles$type1$hove, _tabStyles$type10, _tabStyles$type10$hov, _tabStyles$type11, _tabStyles$type11$hov, _tabStyles$type12, _tabStyles$type12$hov, _tabStyles$type13, _tabStyles$type13$hov, _tabStyles$type$focus2, _tabStyles$type14, _tabStyles$type14$foc, _tabStyles$type$focus3, _tabStyles$type15, _tabStyles$type15$foc, _tabStyles$type16, _tabStyles$type16$foc, _tabStyles$type17, _tabStyles$type17$foc, _tabStyles$type18, _tabStyles$type18$foc, _tabStyles$type19, _tabStyles$type19$foc, _tabStyles$type20, _tabStyles$type20$foc, _tabStyles$type21, _tabStyles$type21$foc;
  var _props$badge = props.badge,
    badge = _props$badge === void 0 ? false : _props$badge,
    badgeColor = props.badgeColor,
    badgeIcon = props.badgeIcon,
    badgeIconType = props.badgeIconType,
    badgeLabel = props.badgeLabel,
    badgeType = props.badgeType,
    _props$current = props.current,
    current = _props$current === void 0 ? false : _props$current,
    disabled = props.disabled,
    dropdownMenu = props.dropdownMenu,
    dropdownMenuProps = props.dropdownMenuProps,
    label = props.label,
    leadingIcon = props.leadingIcon,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    tabSx = props.sx,
    _props$textAlign = props.textAlign,
    textAlign = _props$textAlign === void 0 ? 'center' : _props$textAlign,
    _props$type = props.type,
    type = _props$type === void 0 ? 'buttonPrimary' : _props$type,
    otherTabProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var tabStyles = getTabStyles(theme, current);
  var currentStr = String(current);
  var labelShadow = (_tabStyles$type$curre = (_tabStyles$type$curre2 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre2.shadow) != null ? _tabStyles$type$curre : '';
  var labelLeftBorder = (_tabStyles$type$curre3 = (_tabStyles$type$curre4 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre4.borderLeft) != null ? _tabStyles$type$curre3 : '';
  var hoverLabelLeftBorder = (_tabStyles$type$hover = (_tabStyles$type = tabStyles[type]) == null ? void 0 : (_tabStyles$type$hover2 = _tabStyles$type.hover) == null ? void 0 : _tabStyles$type$hover2.borderLeft) != null ? _tabStyles$type$hover : '';
  var labelBottomBorder = (_tabStyles$type$curre5 = (_tabStyles$type$curre6 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre6.borderBottom) != null ? _tabStyles$type$curre5 : '';
  var hoverLabelBottomBorder = (_tabStyles$type$hover3 = (_tabStyles$type2 = tabStyles[type]) == null ? void 0 : (_tabStyles$type2$hove = _tabStyles$type2.hover) == null ? void 0 : _tabStyles$type2$hove.borderBottom) != null ? _tabStyles$type$hover3 : '';
  var labelColor = (_tabStyles$type$curre7 = (_tabStyles$type$curre8 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre8.label) != null ? _tabStyles$type$curre7 : '';
  var hoverLabelColor = (_tabStyles$type$hover4 = (_tabStyles$type3 = tabStyles[type]) == null ? void 0 : (_tabStyles$type3$hove = _tabStyles$type3.hover) == null ? void 0 : _tabStyles$type3$hove.label) != null ? _tabStyles$type$hover4 : '';
  var labelBgColor = (_tabStyles$type$curre9 = (_tabStyles$type$curre0 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre0.bg) != null ? _tabStyles$type$curre9 : '';
  var hoverLabelBgColor = (_tabStyles$type$hover5 = (_tabStyles$type4 = tabStyles[type]) == null ? void 0 : (_tabStyles$type4$hove = _tabStyles$type4.hover) == null ? void 0 : _tabStyles$type4$hove.bg) != null ? _tabStyles$type$hover5 : '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focusVisible = _useState4[0],
    setFocusVisible = _useState4[1];
  var getBadgeColor = function getBadgeColor() {
    var _tabStyles$type$hover6, _tabStyles$type5, _tabStyles$type5$hove, _tabStyles$type$focus, _tabStyles$type6, _tabStyles$type6$focu, _tabStyles$type$curre1;
    if (disabled) return 'gray';
    if (hover) return (_tabStyles$type$hover6 = (_tabStyles$type5 = tabStyles[type]) == null ? void 0 : (_tabStyles$type5$hove = _tabStyles$type5.hover) == null ? void 0 : _tabStyles$type5$hove.badge) != null ? _tabStyles$type$hover6 : 'gray';
    if (focusVisible) return (_tabStyles$type$focus = (_tabStyles$type6 = tabStyles[type]) == null ? void 0 : (_tabStyles$type6$focu = _tabStyles$type6.focus) == null ? void 0 : _tabStyles$type6$focu.badge) != null ? _tabStyles$type$focus : 'gray';
    return (_tabStyles$type$curre1 = tabStyles[type][currentStr]) == null ? void 0 : _tabStyles$type$curre1.badge;
  };
  var chevronRef = useRef(null);
  var tabTop = (_chevronRef$current$g = (_chevronRef$current = chevronRef.current) == null ? void 0 : _chevronRef$current.getBoundingClientRect().top) != null ? _chevronRef$current$g : 0;
  var tabLeft = (_chevronRef$current$g2 = (_chevronRef$current2 = chevronRef.current) == null ? void 0 : _chevronRef$current2.getBoundingClientRect().left) != null ? _chevronRef$current$g2 : 0;
  var tabHeight = (_chevronRef$current$g3 = (_chevronRef$current3 = chevronRef.current) == null ? void 0 : _chevronRef$current3.getBoundingClientRect().height) != null ? _chevronRef$current$g3 : 0;
  return /*#__PURE__*/_jsx(MuiTab, _extends({
    disabled: disabled,
    label: /*#__PURE__*/_jsxs(Stack, {
      alignItems: "center",
      direction: "row",
      position: "relative",
      spacing: '8px',
      children: [leadingIcon && /*#__PURE__*/_jsx(Icon, {
        iconId: leadingIcon,
        size: 20
      }), /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        noWrap: true,
        variant: "text-".concat(size, "-semibold"),
        children: label
      }), badge && /*#__PURE__*/_jsx(Badge, {
        color: badgeColor || getBadgeColor(),
        disabled: disabled,
        icon: badgeIcon,
        iconType: badgeIconType,
        label: badgeLabel,
        size: size,
        type: badgeType || 'pillColor'
      }), dropdownMenu && /*#__PURE__*/_jsx(DropdownMenu, _extends({
        menuItemProps: [],
        menuPaperProps: {
          sx: {
            position: 'absolute',
            top: tabTop + tabHeight,
            left: tabLeft
          }
        }
      }, dropdownMenuProps, {
        menuTriggerProps: {
          triggerType: 'Custom',
          toggleCustomTriggerOpenOnClick: true,
          CustomTrigger: function CustomTrigger(_ref) {
            var onTriggerClick = _ref.onTriggerClick,
              open = _ref.open;
            return /*#__PURE__*/_jsx(Button, {
              onClick: function onClick(e) {
                e.stopPropagation();
                onTriggerClick();
              },
              sx: {
                color: open ? "".concat(theme.palette.gray[700], "!important") : "".concat(theme.palette.gray[600], "!important"),
                '&:hover': {
                  color: "".concat(theme.palette.gray[700], "!important")
                }
              },
              variant: "link-gray",
              children: /*#__PURE__*/_jsx(Icon, {
                iconId: open ? 'ChevronUp' : 'ChevronDown',
                ref: chevronRef,
                role: "button",
                size: 20
              })
            });
          }
        },
        popperProps: {
          anchorEl: undefined
        }
      }))]
    }),
    onBlur: function onBlur() {
      return setFocusVisible(false);
    },
    onFocusVisible: function onFocusVisible(e) {
      return setFocusVisible(true);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    sx: _extends({
      overflow: 'visible'
    }, tabSx, {
      '&.Mui-disabled': _extends({}, type !== 'lineVertical' && type !== 'underline' && type !== 'buttonWhiteBorder' && {
        backgroundColor: theme.palette.gray[50]
      }, type === 'buttonWhiteBorder' && {
        boxShadow: 'none'
      }, type === 'lineVertical' && {
        borderLeft: 'none'
      }, (type === 'underline' || type === 'underlineFilled') && {
        borderBottom: 'none'
      }, {
        color: "".concat(theme.palette.gray[400], " !important")
      }),
      '&:hover': _extends({
        color: "".concat(hoverLabelColor, " !important"),
        backgroundColor: (_tabStyles$type$hover7 = (_tabStyles$type7 = tabStyles[type]) == null ? void 0 : (_tabStyles$type7$hove = _tabStyles$type7.hover) == null ? void 0 : _tabStyles$type7$hove.bg) != null ? _tabStyles$type$hover7 : 'transparent'
      }, ((_tabStyles$type8 = tabStyles[type]) == null ? void 0 : (_tabStyles$type8$hove = _tabStyles$type8.hover) == null ? void 0 : _tabStyles$type8$hove.shadow) && {
        boxShadow: (_tabStyles$type9 = tabStyles[type]) == null ? void 0 : (_tabStyles$type9$hove = _tabStyles$type9.hover) == null ? void 0 : _tabStyles$type9$hove.shadow
      }, ((_tabStyles$type0 = tabStyles[type]) == null ? void 0 : (_tabStyles$type0$hove = _tabStyles$type0.hover) == null ? void 0 : _tabStyles$type0$hove.borderLeft) && {
        borderLeft: (_tabStyles$type1 = tabStyles[type]) == null ? void 0 : (_tabStyles$type1$hove = _tabStyles$type1.hover) == null ? void 0 : _tabStyles$type1$hove.borderLeft
      }, ((_tabStyles$type10 = tabStyles[type]) == null ? void 0 : (_tabStyles$type10$hov = _tabStyles$type10.hover) == null ? void 0 : _tabStyles$type10$hov.borderBottom) && {
        borderBottom: (_tabStyles$type11 = tabStyles[type]) == null ? void 0 : (_tabStyles$type11$hov = _tabStyles$type11.hover) == null ? void 0 : _tabStyles$type11$hov.borderBottom
      }, ((_tabStyles$type12 = tabStyles[type]) == null ? void 0 : (_tabStyles$type12$hov = _tabStyles$type12.hover) == null ? void 0 : _tabStyles$type12$hov.border) && {
        border: (_tabStyles$type13 = tabStyles[type]) == null ? void 0 : (_tabStyles$type13$hov = _tabStyles$type13.hover) == null ? void 0 : _tabStyles$type13$hov.border
      }),
      '&:focus-visible': _extends({
        color: hover ? "".concat(hoverLabelColor, " !important") : "".concat((_tabStyles$type$focus2 = (_tabStyles$type14 = tabStyles[type]) == null ? void 0 : (_tabStyles$type14$foc = _tabStyles$type14.focus) == null ? void 0 : _tabStyles$type14$foc.label) != null ? _tabStyles$type$focus2 : '', " !important"),
        backgroundColor: hover ? hoverLabelBgColor : (_tabStyles$type$focus3 = (_tabStyles$type15 = tabStyles[type]) == null ? void 0 : (_tabStyles$type15$foc = _tabStyles$type15.focus) == null ? void 0 : _tabStyles$type15$foc.bg) != null ? _tabStyles$type$focus3 : 'transparent'
      }, ((_tabStyles$type16 = tabStyles[type]) == null ? void 0 : (_tabStyles$type16$foc = _tabStyles$type16.focus) == null ? void 0 : _tabStyles$type16$foc.shadow) && {
        boxShadow: (_tabStyles$type17 = tabStyles[type]) == null ? void 0 : (_tabStyles$type17$foc = _tabStyles$type17.focus) == null ? void 0 : _tabStyles$type17$foc.shadow
        // outline: '4px solid red',
      }, ((_tabStyles$type18 = tabStyles[type]) == null ? void 0 : (_tabStyles$type18$foc = _tabStyles$type18.focus) == null ? void 0 : _tabStyles$type18$foc.borderLeft) && {
        borderLeft: hover ? hoverLabelLeftBorder : (_tabStyles$type19 = tabStyles[type]) == null ? void 0 : (_tabStyles$type19$foc = _tabStyles$type19.focus) == null ? void 0 : _tabStyles$type19$foc.borderLeft
      }, ((_tabStyles$type20 = tabStyles[type]) == null ? void 0 : (_tabStyles$type20$foc = _tabStyles$type20.focus) == null ? void 0 : _tabStyles$type20$foc.borderBottom) && {
        borderBottom: hover ? hoverLabelBottomBorder : (_tabStyles$type21 = tabStyles[type]) == null ? void 0 : (_tabStyles$type21$foc = _tabStyles$type21.focus) == null ? void 0 : _tabStyles$type21$foc.borderBottom
      }),
      color: "".concat(labelColor, " !important"),
      backgroundColor: labelBgColor,
      boxShadow: labelShadow,
      alignItems: textAlign === 'center' ? textAlign : 'flex-start'
    }, (type === 'buttonPrimary' || type === 'buttonGray' || type === 'buttonPrimaryBorder' || type === 'buttonWhiteBorder') && {
      borderRadius: '6px'
    }, size === 'md' && {
      padding: '10px 14px'
    }, type === 'underline' && {
      padding: '0px 4px 12px 4px'
    }, type === 'underlineFilled' && {
      padding: '12px 12px'
    }, type === 'buttonPrimaryBorder' && {
      padding: '6px 11px',
      border: "1px solid ".concat(current && !disabled ? theme.palette.primary[100] : 'transparent')
    }, labelBottomBorder && {
      borderBottom: labelBottomBorder
    }, type === 'lineVertical' && {
      borderLeft: '2px solid transparent'
    }, labelLeftBorder && {
      borderLeft: labelLeftBorder
    }, {
      overflowY: 'visible'
    }),
    tabIndex: 0
  }, otherTabProps, {
    "data-element": "MuiTab",
    "data-component": "TabButton",
    "data-source-file": "TabButton.tsx"
  }));
}